import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';

interface UserProfile {
  username: string;
  email: string;
  phone_number?: string;
}

const UserProfileDisplay: React.FC = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const session = await Auth.currentSession();
        const userInfo = session.getIdToken().payload;
        setUserProfile({
          username: userInfo['cognito:username'],
          email: userInfo.email,
          phone_number: userInfo.phone_number,
        });
      } catch (error) {
        setError('Failed to fetch user profile.');
        console.error('Error fetching user profile:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  if (isLoading) return <div>Loading user profile...</div>;
  if (error) return <div>{error}</div>;
  if (!userProfile) return <div>No user profile data available.</div>;

  return (
    <div>
      <h2>User Profile</h2>
      <p><strong>Username:</strong> {userProfile.username}</p>
      <p><strong>Email:</strong> {userProfile.email}</p>
      {userProfile.phone_number && <p><strong>Phone Number:</strong> {userProfile.phone_number}</p>}
    </div>
  );
};

export default UserProfileDisplay;